import { useQuery } from "@tanstack/react-query";
import { patientIntakeApi } from "@/lib/patientIntakeApi";

/**
 * React hook to fetch and cache specialties from the backend API
 * Filters out dental/dentistry specialties client-side as backup
 */
export function useSpecialties() {
  const { data, isLoading, error } = useQuery({
    queryKey: ["patient-intake-specialties"],
    queryFn: async () => { 
      const response = await patientIntakeApi.getSpecialties();
      // Double-filter: exclude dental/dentistry specialties as backup
      // const filtered = response.data.filter(
      //   (specialty) =>
      //     specialty.slug !== "dentistry" &&
      //     specialty.category !== "dental" 
      //     && specialty.category !== "dentistry"
      // );
      console.log(response.data);
      return response.data; 
    },
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
    gcTime: 10 * 60 * 1000, // Keep in cache for 10 minutes
  });

  return {
    specialties: data ?? [],
    isLoading,
    error,
  };
}

